import React from 'react';
import classnames from 'classnames';

import './Label.scss';

export interface LabelProps {
  className?: string;
  label?: string;
  required?: boolean;
}

const Label = ({ className, label, required }: LabelProps) => {
  return (
    <div
      className={classnames(
        'label',
        {
          'label-required': !!required,
        },
        className,
      )}
    >
      {label}
    </div>
  );
};

export default Label;
